module.exports = __webpack_public_path__ + "img/image2.84db8d89.png";